{
  "_provenance": {
    "ns": "chat",
    "source": "the chat: core.* is the chat-core copy pack (lane L5a); every other section is pages/ChatPage.tsx, the widget, handoff and receipts (lane L5b) (#2109 R3)"
  },
  "actionCard": {
    "fields": {
      "category": "Category",
      "duration": "Duration",
      "note": "Note",
      "title": "Title",
      "when": "When"
    },
    "minutes_one": "{{count}} min",
    "minutes_other": "{{count}} min",
    "notNow": "Not now",
    "task": {
      "ask": "Add this to your task queue?",
      "confirm": "Add task",
      "done": "Added to your queue.",
      "eyebrow": "Task draft"
    }
  },
  "actionToasts": {
    "done": "Done",
    "failed": "Something went wrong. Please try again.",
    "taskAdded": "Task \"{{title}}\" added to your queue.",
    "undoFailed": "Couldn’t undo that",
    "undoFailedBody": "You can remove it manually from the relevant page.",
    "undone": "Undone",
    "undoneBody": "That action was reversed."
  },
  "archive": {
    "untitled": "Conversation"
  },
  "composer": {
    "attachDocument": "Attach a file (docx, xlsx, pptx, pdf, png, jpg, txt)",
    "attachReceipt": "Attach a receipt (photo or PDF)",
    "dictate": "Dictate a message",
    "discardDictation": "Discard dictation",
    "fileErrors": {
      "legacyDoc": "Legacy .doc files aren’t supported — save as .docx and retry.",
      "noExtension": "That file has no extension. Attach a docx, xlsx, pptx, pdf, png, jpg, or txt file.",
      "unsupported": ".{{ext}} files aren’t supported. Attach a docx, xlsx, pptx, pdf, png, jpg, or txt file."
    },
    "inputLabel": "Chat message input",
    "placeholder": "Ask {{companion}} anything…",
    "removeAttachment": "Remove attachment",
    "removeFile": "Remove file",
    "send": "Send message",
    "sendHint": "Send",
    "status": {
      "attached": "Attached",
      "failed": "Failed",
      "submitted": "Submitted",
      "uploading": "Uploading…"
    },
    "stopDictation": "Stop dictation",
    "stopDictationHint": "Stop dictation (keeps what you said)",
    "toolbarLabel": "Composer controls",
    "tooLong": "This message is {{length}} characters — the maximum is {{max}}. Please split it into smaller messages."
  },
  "core": {
    "actions": {
      "copied": "Copied",
      "copyMessage": "Copy message",
      "retryMessage": "Regenerate reply"
    },
    "attachments": {
      "buttonTitle": "Attach an image, PDF, text file (.txt, .md), Office document (.docx, .xlsx, .pptx), or meeting transcript (.vtt, .sbv)",
      "unsupported": "Only images (JPEG, PNG, WebP, GIF), PDFs, text files (.txt, .md), Office documents (.docx, .xlsx, .pptx), and meeting transcripts (.vtt, .sbv) are supported."
    },
    "bubble": {
      "trferSender": "Your case manager",
      "userLabel": "You"
    },
    "bubbleChrome": {
      "attachment": {
        "image": "Image attachment",
        "pdf": "PDF attachment",
        "text": "Text attachment"
      },
      "flag": {
        "ariaLabel": "Flag this message as an insight to review",
        "failed": "Couldn’t flag that — try again",
        "flagged": "Flagged — review it on your Insights page",
        "idle": "Flag as insight"
      },
      "from": "Message from {{name}}",
      "fromUser": "Message from you",
      "reactions": {
        "bad": "Bad response",
        "good": "Good response",
        "regionLabel": "Message reactions"
      },
      "status": {
        "delivered": "Message delivered",
        "error": "Message error",
        "sending": "Message sending",
        "sent": "Message sent"
      },
      "thinkingLabel": "Thought process",
      "thinkingToggle": "Toggle extended thinking"
    },
    "cardCopy": {
      "calibration": {
        "approve": "Approve",
        "ariaLabel": "Entry for review",
        "clickToEdit": "Click to edit",
        "delete": "Delete",
        "edit": "Edit",
        "hold": "Hold",
        "title": "Review entry"
      }
    },
    "chips": {
      "regionLabel": "Suggested replies"
    },
    "composer": {
      "ariaLabel": "Type your message",
      "hint": "Press Enter to send, Shift+Enter for new line",
      "logout": "Logout",
      "placeholder": "Type your message...",
      "send": "Send message",
      "sending": "Sending message..."
    },
    "dialog": {
      "close": "Close"
    },
    "dictation": {
      "micDenied": "Microphone access needed. Please enable it in your browser settings.",
      "micFailed": "Failed to access the microphone. Please check your browser settings.",
      "transcribeFailed": "Failed to transcribe audio. Please try again.",
      "transcribeFailedStatus": "Transcription failed ({{status}})",
      "unsupported": "Dictation isn’t supported in this browser."
    },
    "drawer": {
      "cancel": "Cancel",
      "channels": {
        "call": "Call",
        "sms": "SMS",
        "voice": "Voice",
        "whatsapp": "WhatsApp"
      },
      "clearSearch": "Clear search",
      "copied": "Copied!",
      "copyAll": "Copy all",
      "copyRange": "Copy range",
      "customEmpty": "Click messages in the chat to mark the start and end.",
      "delete": "Delete",
      "deleteBody": "This permanently removes this conversation and everything in it. There is no undo.",
      "deleteThread": "Delete this thread",
      "deleteTitle": "Delete this conversation?",
      "deleting": "Deleting…",
      "download": "Download",
      "downloadAs": "Download as",
      "downloadDisabledHint": "Start a conversation first",
      "downloadHint": "Download, copy or delete this conversation",
      "empty": "No conversations yet.",
      "endSession": "End session",
      "endSessionDisabledHint": "Nothing to end yet",
      "exportDescription": "Download and Copy use the selected range.",
      "exportDocx": "Export .docx",
      "exporting": "Exporting…",
      "exportPdf": "Export .pdf",
      "exportTitle": "This conversation",
      "fontScales": {
        "lg": "Large",
        "md": "Medium",
        "sm": "Small"
      },
      "formats": {
        "markdown": "Markdown (.md)",
        "pdf": "PDF (.pdf)",
        "plainText": "Plain text (.txt)",
        "preparingPdf": "Preparing PDF…",
        "preparingWord": "Preparing Word document…",
        "word": "Word (.docx)"
      },
      "groups": {
        "earlier": "Earlier",
        "thisWeek": "This week",
        "today": "Today"
      },
      "historyLabel": "Conversation history",
      "loadFailed": "Couldn’t load conversations.",
      "loading": "Loading…",
      "newConversation": "New conversation",
      "noMatches": "No conversations match '{{query}}'",
      "range": "Range",
      "rangeEmpty": "No messages in this range.",
      "rangeLabel": "Export range",
      "recents": "Recents",
      "recentsView": "Recents view",
      "rename": "Rename",
      "renameFailed": "Couldn’t rename this conversation. Please try again.",
      "renameLabel": "Conversation name",
      "renameSave": "Save",
      "renameSaving": "Saving…",
      "renameTitle": "Rename this conversation",
      "resizeLabel": "Resize conversation history panel",
      "retry": "Retry",
      "rowActions": "Conversation actions",
      "searchConversations": "Search conversations",
      "searchFooter_one": "Searches the {{count}} most recent titles. Esc to close.",
      "searchFooter_other": "Searches the {{count}} most recent titles. Esc to close.",
      "slices": {
        "custom": "Custom",
        "everything": "Everything",
        "today": "Today",
        "week": "This week"
      },
      "textSize": "Text size",
      "title": "Conversations",
      "toolsLabel": "Conversation tools",
      "ungrouped": "Ungrouped",
      "untitledWithChannel": "{{date}} · {{channel}}",
      "viewAll": "View all conversations →",
      "viewHints": {
        "recent": "Newest first, grouped by day.",
        "topics": "Grouped by what each conversation was about."
      },
      "viewOptions": "View options",
      "viewOptionsHint": "Recent or Topics, text size",
      "views": {
        "recent": "Recent",
        "topics": "Topics"
      },
      "withHint": "{{label}} — {{hint}}"
    },
    "errorBoundary": {
      "body": "There was an error in the chat. Please try refreshing or contact support if the problem persists.",
      "details": "Error details",
      "retry": "Try again",
      "title": "Something went wrong"
    },
    "export": {
      "failed": "Export failed ({{status}})",
      "labels": {
        "exported": "Exported",
        "from": "From",
        "generated": "Generated",
        "sessionId": "Session ID",
        "time": "Time",
        "totalMessages": "Total Messages",
        "version": "Version"
      },
      "markdownTitle": "Conversation export",
      "markdownVersionLabel": "Conversation with {{companion}}",
      "messageHeading": "Message {{position}}",
      "noMessagesInRange": "No messages in the selected range.",
      "nothingToExport": "No conversation to export yet.",
      "preparing": "Preparing…",
      "printPdf": "Print / PDF",
      "printScopeNote": "This is the conversation as it stands now. If an answer was regenerated, only its current version appears here.",
      "spokenSuffix": " (spoken)",
      "textHeaderSubtitle": "A conversation with {{companion}}",
      "textHeaderTitle": "Conversation",
      "unknownSession": "unknown",
      "userLabel": "You"
    },
    "failures": {
      "agentError": {
        "bubble": "⚠️ I couldn’t finish this reply — {{reason}}",
        "bubbleNoReason": "⚠️ I couldn’t finish this reply. Try again in a moment.",
        "summaryFallback": "I could not complete this reply."
      },
      "connectFailed": {
        "bubble": "⚠️ Your message never reached me — {{reason}}",
        "bubbleNoReason": "⚠️ Your message never reached me. Try sending it again in a moment.",
        "summaryFallback": "Your message never reached me."
      },
      "interrupted": {
        "bubbleAfterPartial": "⚠️ The connection dropped part-way through this reply — what you see above is all that arrived. Send your message again to get the rest.",
        "bubbleAtStart": "⚠️ The connection dropped just as my reply was starting. Try sending that again.",
        "summary": "The connection dropped part-way through my reply."
      },
      "notOpened": {
        "bubble": "⚠️ Your message didn’t reach me — the connection never opened. That is usually a network drop. Try again; if it keeps happening, reload the page and check you’re still signed in.",
        "summary": "The connection never opened."
      },
      "refused": {
        "bubble": "⚠️ Your message didn’t reach me — {{reason}} Try again; if it keeps happening, reload the page and check you’re still signed in.",
        "summary": "Your message didn’t go through."
      },
      "refusedMessageTooLong": {
        "bubble": "⚠️ That message is too long to send in one go. Your text is still shown above — copy it and send it in a couple of smaller parts.",
        "summary": "This message is too long to send in one go."
      },
      "retryNotPersisted": {
        "conflict": "⚠️ This answer was regenerated, but the conversation had already moved on, so the earlier reply above is the one on record.",
        "summary": "The regenerated reply could not be saved.",
        "transient": "⚠️ This answer was regenerated, but saving it couldn’t be confirmed, so the earlier reply has been put back. Try again in a moment, or reload to see what was stored."
      },
      "sendRejected": {
        "bubble": "⚠️ I couldn’t take that message. Try again in a moment.",
        "bubbleNoStatus": "⚠️ That message couldn’t be sent. Try again in a moment.",
        "summary": "Your message didn’t go through.",
        "summaryNoStatus": "Your message could not be sent."
      },
      "streamTimeout": {
        "bubbleAfterPartial": "⚠️ I stopped part-way through this reply — it ran past the time limit. Everything above did come through. Send your message again and I’ll pick it back up.",
        "bubbleNoContent": "⚠️ I took too long to reply and the request timed out. Try sending that again.",
        "summary": "I took too long to finish this reply."
      }
    },
    "messageList": {
      "emptyBody": "Write to {{companion}} about anything — a bill, a date to remember, or how today is going.",
      "emptyTitle": "Start the conversation",
      "historyLoadFailed": "Failed to load conversation history. Starting fresh conversation.",
      "jumpToLatest": "Jump to latest",
      "regionLabel": "Chat messages",
      "selectForRange": "Select message {{position}} for the export range",
      "unavailable": "Your companion is currently unavailable"
    },
    "recall": {
      "hideDetails": "Hide",
      "line": "Drawing on what you’ve told me before",
      "showDetails": "What I recalled"
    },
    "sessionEnded": {
      "ended": "This session has ended.",
      "resume": "Continue this conversation",
      "resuming": "Resuming…",
      "startNew": "Start a new session",
      "voiceViewOnly": "This was a voice session — the transcript is view-only here."
    },
    "thinking": {
      "initial": "Reading your message",
      "progressive": {
        "checking": "Checking what I know about your family",
        "composing": "Putting a reply together",
        "thinking": "Thinking this through"
      }
    },
    "typing": {
      "ariaLabel": "{{sender}} is typing",
      "label": "typing..."
    },
    "upload": {
      "failedStatus": "Upload failed ({{status}})",
      "unreachable": "That file didn’t reach me — the connection dropped on the way. Check you’re online and try attaching it again."
    },
    "voice": {
      "controls": {
        "end": "End call",
        "expand": "Expand call",
        "minimize": "Minimize call",
        "mute": "Mute microphone",
        "retry": "Try again",
        "unmute": "Unmute microphone"
      },
      "duplexUnavailable": "Typing isn’t reaching this call — I’ll pause your message until the call ends.",
      "failures": {
        "agentAbsent": "I didn’t pick up. Try again in a moment — or keep typing.",
        "micDenied": "Microphone access was blocked. Allow it and try again — or keep typing.",
        "micMissing": "No microphone was found on this device. Keep typing and I’ll answer here.",
        "network": "The connection dropped. Try again — or keep typing.",
        "unavailable": "Voice isn’t available right now. Keep typing and I’ll answer here."
      },
      "regionLabel": "Voice call",
      "states": {
        "connecting": "Connecting…",
        "connectingSlow": "Still connecting.",
        "endedMinutes_one": "Ended · {{count}} min",
        "endedMinutes_other": "Ended · {{count}} min",
        "endedSeconds_one": "Ended · {{count}} sec",
        "endedSeconds_other": "Ended · {{count}} sec",
        "listening": "Listening",
        "muted": "Muted",
        "requesting": "Asking for your microphone…",
        "speaking": "{{companion}} is speaking"
      }
    }
  },
  "dictation": {
    "micBlocked": "Microphone access is blocked. Allow it in your browser settings, then try again.",
    "network": "Dictation needs a network connection and couldn’t reach the speech service.",
    "noMic": "No microphone found. Check that one is connected and try again.",
    "noSpeech": "We didn’t catch any speech. Try again a little closer to the mic.",
    "startFailed": "Dictation couldn’t start. Try again.",
    "stopped": "Dictation stopped unexpectedly. Try again, or type your message.",
    "unsupportedBrowser": "Dictation couldn’t start in this browser. Type your message instead."
  },
  "errorRow": {
    "dismiss": "Dismiss error",
    "generic": "Something went wrong. Please try again.",
    "retry": "Retry"
  },
  "handoff": {
    "aCaseManager": "A case manager",
    "anotherCaseManager": "another case manager",
    "caseManager": "Case manager",
    "eta": {
      "anyMoment": "any moment",
      "hours_one": "{{count}} hour",
      "hours_other": "{{count}} hours",
      "minutes_one": "{{count}} min",
      "minutes_other": "{{count}} min",
      "soon": "soon"
    },
    "event": {
      "handback": "— {{name}} handed the conversation back to {{companion}} —",
      "joined": "— {{name}} from TRF joined this conversation —",
      "reassigned": "— Reassigned to {{name}} —"
    },
    "loopIn": {
      "failed": "Couldn’t request a case manager right now",
      "label": "Loop in my case manager",
      "pending": "Looping your case manager in…"
    },
    "nudge": {
      "accept": "Yes please",
      "claimStress": {
        "body": "One of your reimbursements has not moved. Would you like a case manager to chase it for you?",
        "title": "A reimbursement looks stuck"
      },
      "decline": "Not right now",
      "failed": "That didn’t go through. Please try again.",
      "lifecycle": {
        "body": "Today marks a milestone in your journey. Would you like a case manager to be in touch?",
        "title": "A case manager would like to check in"
      },
      "silence": {
        "body": "I noticed it’s been a hard few days. Would you like someone from TRF to reach out?",
        "title": "Want a case manager to check in?"
      }
    },
    "original": {
      "report": "Report bad translation",
      "reported": "Report submitted",
      "reportedBody": "TRF leads will review this translation.",
      "reportFailed": "Couldn’t submit the report",
      "reportFailedBody": "Please try again in a moment.",
      "submitting": "Submitting…",
      "title": "Original ({{language}})"
    },
    "pill": {
      "claimed": "A case manager is in this conversation",
      "claimedNamed": "{{name}} from TRF is in this conversation",
      "dismissAlert": "Dismiss alert",
      "slaBreached": "We’re working to connect you with someone — please hold on.",
      "waiting": "A case manager will join · ETA {{eta}}"
    },
    "translation": {
      "bannerCollapsed": "Translation active · AI-generated, not perfect.",
      "bannerDirections": "Their messages → {{theirs}}. Your messages → {{yours}}.",
      "bannerNote": "Translated by AI · not perfect · tap any message to see the original.",
      "bannerTitle": "You and {{name}} are speaking different languages.",
      "retry": "Retry",
      "retryFailed": "Retry failed",
      "retryFailedBody": "Couldn’t request a new translation. Please try again.",
      "translatedFrom": "↳ Translated from {{language}}",
      "unavailable": "Translation unavailable — showing original.",
      "viewOriginal": "View original"
    },
    "trferBubble": {
      "author": "{{name}} · TRF Family Support",
      "showingOriginal": "↳ Showing original {{language}} — tap to hide",
      "translatedFrom": "↳ Translated from {{language}} — tap to view original"
    }
  },
  "history": {
    "current": "Current",
    "dormant": "Dormant",
    "empty": "No saved threads yet.",
    "heading": "Conversations",
    "loadFailed": "Couldn’t load your conversations. Please try again.",
    "loading": "Loading threads…",
    "title": "Threads with <0>{{companion}}</0>.",
    "trigger": "Conversation history",
    "untitled": "Untitled conversation"
  },
  "idle": {
    "appointment": {
      "ask": "Help me get ready for \"{{title}}\" — what should I bring, what questions should I ask?",
      "body_one": "{{title}} is in {{count}} day. Want help getting ready — questions to ask, what to bring?",
      "body_other": "{{title}} is in {{count}} days. Want help getting ready — questions to ask, what to bring?",
      "cta": "Prep with me",
      "fallbackTitle": "Your next appointment"
    },
    "fallback": {
      "body": "{{companion}} is ready when you are. Try one of the prompts below, or just type.",
      "eyebrow": "Chat",
      "title": "What’s on your mind?"
    },
    "heading_one": "One thing to start with.",
    "heading_other": "{{count}} things to start with.",
    "noticed": "{{companion}} · noticed",
    "overdue": {
      "ask": "I have some overdue tasks. Can you help me work out what’s still worth doing this week and what I can let go of?",
      "body_one": "{{count}} task slipped past — want me to walk through what’s still worth doing vs. what can wait?",
      "body_other": "{{count}} tasks slipped past — want me to walk through what’s still worth doing vs. what can wait?",
      "cta": "Triage them"
    },
    "today": {
      "ask": "What should I tackle first today? Help me sequence my tasks.",
      "body": "{{n}} things on the list for today. Want to order them by what’ll feel best to knock out first?",
      "cta": "Let’s plan it"
    }
  },
  "page": {
    "companionLanguageNote": "{{companion}} replies in English for now — you can still write in your language. <0>Companion language settings</0>",
    "composerPlaceholder": "Ask {{companion}} anything…",
    "connectFailed": {
      "body": "The conversation stream is not responding. Check your connection, or try again.",
      "title": "Couldn’t connect to {{companion}}."
    },
    "deleteDialog": {
      "body": "This permanently removes the conversation and every message in it. There’s no undo.",
      "confirm": "Delete conversation",
      "dontShowAgain": "Don’t show again",
      "eyebrow": "Delete conversation",
      "permanent": "Permanent · cannot be undone",
      "title": "Forget this thread for good?"
    },
    "handoffComposer": {
      "banner": "A case manager is in this conversation — your messages go to them, not {{companion}}.",
      "placeholder": "Reply to your case manager…"
    },
    "rail": {
      "hide": "Hide conversations"
    },
    "resumeFailed": "That session could not be resumed. Start a new one instead.",
    "retry": "Retry",
    "selection": {
      "clear": "Clear",
      "pickEnd": "1 message selected — click another to mark the end.",
      "selected_one": "{{count}} message selected — open Download in the sidebar to export them.",
      "selected_other": "{{count}} messages selected — open Download in the sidebar to export them.",
      "start": "Click a message to mark the start of the range."
    },
    "toasts": {
      "deleteFailed": "Couldn’t delete the conversation",
      "loopInFailed": "Couldn’t loop in your case manager",
      "printFailed": "Couldn’t open the print dialog",
      "printFailedRetry": "Try again.",
      "voiceUpdated": "Voice updated",
      "voiceUpdatedBody": "Your new voice takes effect next session."
    },
    "yourCaseManager": "your case manager"
  },
  "pageError": {
    "body": "The chat encountered an unexpected error. Refresh the page to try again.",
    "retry": "Try Again",
    "title": "Something went wrong"
  },
  "personas": {
    "calm-anchor": {
      "name": "Stephanie - The Calm Anchor",
      "tagline": "Soft, unhurried. Perfect for late nights and heavy moments."
    },
    "clear-explainer": {
      "name": "Aria - The Clear Explainer",
      "tagline": "Patient and clear. Makes confusing things make sense without being clinical."
    },
    "practical-helper": {
      "name": "Maya - The Practical Helper",
      "tagline": "Warm and organized. Gets things done without feeling rushed."
    },
    "steady-companion": {
      "name": "Stevens - The Steady Companion",
      "tagline": "Gentle and kind — the friend who shows up and does not make it awkward."
    },
    "thoughtful-listener": {
      "name": "Willow - The Thoughtful Listener",
      "tagline": "Measured and empathetic. Feels like every word is heard before a response comes."
    },
    "wise-guide": {
      "name": "Sage - The Wise Guide",
      "tagline": "Experienced and warm — like a trusted advisor who has navigated this before."
    }
  },
  "receiptToast": {
    "description": "{{message}} — nothing was saved. Please try again.",
    "descriptionGeneric": "Nothing was saved. Please try again.",
    "title": "Receipt not submitted",
    "uploadFailed": "Upload failed"
  },
  "system": {
    "handback": "Case manager handed back to {{companion}}",
    "handoffInitiated": "Asking a case manager to join this conversation…",
    "reassigned": "Reassigned to {{name}}",
    "slaBreached": "We’re still working to connect you with someone — please hold on.",
    "trferIdleReleased": "Your case manager stepped away — {{companion}} is here while we re-route.",
    "trferJoined": "{{name}} from TRF joined"
  },
  "time": {
    "activeNow": "Active now",
    "daysAgo_one": "{{count}}d ago",
    "daysAgo_other": "{{count}}d ago",
    "hoursAgo_one": "{{count}}h ago",
    "hoursAgo_other": "{{count}}h ago",
    "minutesAgo_one": "{{count}}m ago",
    "minutesAgo_other": "{{count}}m ago",
    "overAWeek": "> 1 week"
  },
  "transcript": {
    "bookmark": "Bookmark message",
    "removeBookmark": "Remove bookmark",
    "today": "Today",
    "yesterday": "Yesterday"
  },
  "voiceButton": {
    "end": "End voice session",
    "start": "Start voice session"
  },
  "voiceSetup": {
    "changeLater": "You can change this anytime in Settings",
    "edit": {
      "confirm": "Save voice",
      "eyebrow": "Edit voice",
      "title": "Pick {{companion}}'s voice."
    },
    "firstTime": {
      "confirm": "Start session",
      "eyebrow": "First-time voice setup",
      "title": "Who should {{companion}} sound like?"
    },
    "languageBeta": "Spanish and Mandarin support is in beta — prompts and voices are being polished.",
    "languageLabel": "Voice language",
    "loading": "Loading voices…",
    "pausePreview": "Pause preview",
    "playPreview": "Play preview"
  },
  "widget": {
    "contract": "Contract chat",
    "empty": {
      "hint": "Type a message or tap a chip below.",
      "title": "{{companion}} is here whenever you need."
    },
    "expand": "Expand chat",
    "launcher": "{{companion}} is here",
    "minimize": "Minimize chat",
    "newConversation": "New conversation",
    "panelLabel": "Chat with {{name}}",
    "placeholder": "Ask {{companion}}…"
  },
  "widgetChips": {
    "bills": {
      "explainCharge": {
        "label": "Explain this charge",
        "message": "Explain this charge"
      },
      "trfHelp": {
        "label": "What can TRF help with?",
        "message": "What can TRF help with?"
      }
    },
    "calendar": {
      "addAppointment": {
        "label": "Add appointment",
        "message": "Add appointment"
      },
      "thisWeek": {
        "label": "What’s this week look like?",
        "message": "What’s this week look like?"
      }
    },
    "community": {
      "othersSaying": {
        "label": "What’s new from TRF?",
        "message": "What has TRF posted lately?"
      }
    },
    "default": {
      "focusToday": {
        "label": "What should I focus on today?",
        "message": "What should I focus on today?"
      },
      "howCanIHelp": {
        "label": "How can I help?",
        "message": "How can I help?"
      }
    },
    "help": {
      "mostUseful": {
        "label": "What’s most useful for me?",
        "message": "What sections of the platform should I focus on first?"
      },
      "tour": {
        "label": "Show me around",
        "message": "Give me a quick tour of the platform and explain what each section does"
      }
    },
    "medical": {
      "doctorQuestions": {
        "label": "Questions for the doctor",
        "message": "Questions for the doctor"
      },
      "logSymptom": {
        "label": "Log a symptom",
        "message": "Log a symptom"
      }
    },
    "tasks": {
      "addRequest": {
        "label": "Add a request",
        "message": "I want to add a help request to my task list"
      },
      "whatToAsk": {
        "label": "What should I ask for?",
        "message": "What kinds of help should I add to my task list right now?"
      }
    }
  }
}
